function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingSpeakerSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F7F7F"
    },
    d: "M499.449,176.668C466.055,74.12,369.691,0,256,0C114.615,0,0,114.616,0,256 c0,129.194,95.709,236.018,220.09,253.48L499.449,176.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595959"
    },
    d: "M512,256c0-27.694-4.415-54.353-12.551-79.332l-82.058-82.059L395.13,254.74L38.957,311.652 l128.557,128.557l-6.122,10.574l58.699,58.697c11.735,1.648,23.72,2.52,35.91,2.52C397.385,512,512,397.384,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2"
    },
    d: "M222.949,428.58l-17.036-72.406l-66.783-22.261l55.652,116.87h49.292 C244.075,438.922,234.667,429.18,222.949,428.58z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "167.284,333.913 139.13,356.174 161.391,450.783 194.783,450.783 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 300.522,
    style: {
      fill: "#FFFFFF"
    },
    width: 89.043,
    height: 55.652
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBE287"
    },
    d: "M395.13,116.87c-50.774,38.719-112.059,61.217-178.087,61.217l-44.522,100.174h244.87L395.13,116.87z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD652"
    },
    d: "M172.522,256l44.522,77.913c66.028,0,127.313,22.498,178.087,61.217L417.391,256H172.522z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "406.261,211.478 406.261,278.261 461.913,256 461.913,222.609 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7EDBC"
    },
    points: "406.261,256 406.261,300.522 461.913,289.391 461.913,256 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F15D4A"
    },
    points: "83.478,200.348 38.957,200.348 38.957,256 115.464,300.522 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E24642"
    },
    points: "38.957,256 38.957,311.652 83.478,311.652 115.464,256 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F15D4A"
    },
    points: "217.043,256 150.261,201.754 83.478,256 83.478,333.913 217.043,333.913 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 83.478,
    y: 178.087,
    style: {
      fill: "#FF7452"
    },
    width: 133.565,
    height: 77.913
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF7452"
    },
    points: "150.261,256 128,227.256 105.739,256 105.739,311.652 150.261,311.652  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.739,
    y: 200.348,
    style: {
      fill: "#FF9075"
    },
    width: 44.522,
    height: 55.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.13,
    y: 94.609,
    style: {
      fill: "#FDBA4C"
    },
    width: 22.261,
    height: 322.783
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingSpeakerSvgrepoCom);
export default __webpack_public_path__ + "static/media/marketing-speaker-svgrepo-com.301f509238cddd585ebcecfb907d7a4e.svg";
export { ForwardRef as ReactComponent };